import { createRouter, createWebHistory } from 'vue-router'

/* ---------- 页面组件 ---------- */
import Home from '@/views/Home.vue'
import AboutCompany from '@/views/AboutCompany.vue'
import Product from '@/views/Product.vue'
import Tech from '@/views/Tech.vue'
import Scene from '@/views/Scene.vue'
import Contact from '@/views/Contact.vue'
import Download from '@/views/Download.vue'
import Legal from '@/views/Legal.vue'

const routes = [
  /* 首页 - 所有设备统一访问同一个组件 */
  { path: '/', name: 'home', component: Home, meta: { title: '首页' } },
  
  /* 6 个功能页 */
  { path: '/about-company', name: 'AboutCompany', component: AboutCompany, meta: { title: '公司介绍' } },
  { path: '/product', name: 'Product', component: Product, meta: { title: '产品介绍' } },
  { path: '/tech', name: 'Tech', component: Tech, meta: { title: '技术核心' } },
  { path: '/scene', name: 'Scene', component: Scene, meta: { title: '应用场景' } },
  { path: '/contact', name: 'Contact', component: Contact, meta: { title: '联系我们' } },
  { path: '/download', name: 'Download', component: Download, meta: { title: '下载中心' } },

  /* 页脚法务页：共用 Legal.vue，用 props 区分内容 */
  {
    path: '/privacy',
    name: 'Privacy',
    component: Legal,
    props: { type: 'privacy' },
    meta: { title: '隐私政策' }
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Legal,
    props: { type: 'terms' },
    meta: { title: '服务条款' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  /* 切换路由时回到顶部；浏览器前进/后退时恢复原位置 */
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    /* 支持 #锚点 跳转，留出固定导航栏的高度 */
    if (to.hash) return { el: to.hash, top: 88 }
    return { top: 0 }
  }
})

/* 每个页面设置独立的浏览器标题，方便收藏与搜索收录 */
router.afterEach((to) => {
  const siteName = '无锡特文思达健康科技有限公司'
  document.title = to.meta && to.meta.title ? `${to.meta.title} · ${siteName}` : siteName
})

/* 
  注意：已删除设备检测逻辑
  现在所有设备都从 Home.vue 入口访问
  需要在 Home.vue 组件内部实现响应式设计
*/

export default router
